import React, {useMemo} from 'react';
import Modal from '../../../../Components/Modal';
import { useConnectBank } from '../../../../Data/Payments';
import Search, { SearchBar, useSearch } from '../../../../Components/Search';
import { useDialogues } from '../../../../Components/Dialogues';
import { ulid } from 'ulid';
import { useNewWindow } from '../../../../Services/helpers';

/*
{
    "id": "ABNAMRO_ABNAGB2LXXX",
    "name": "ABN AMRO Bank Commercial",
    "bic": "ABNAGB2LXXX",
    "transaction_total_days": "540",
    "countries": [
        "GB"
    ],
    "logo": "https://cdn.nordigen.com/ais/ABNAMRO_FTSBDEFAXXX.png"
}
*/

const ConnectABank = ({isOpen, setIsOpen, onConnected}) => {
    const {banks, connectBank} = useConnectBank();
    const {confirm} = useDialogues();
    const newWindow = useNewWindow();

    const handleSelect = async (e, bank) => {
        e.preventDefault();
        confirm(
            {
                theme: 'primary',
                title: 'Connect '+bank.name+'?',
                message: `Are you sure you want to setup a connection to ${bank.name}?\nWe'll redirect you to our open banking provider Nordigen, who will connect you to ${bank.name}.`
            },
            async () => {
                const newBank = await connectBank(bank.id, ulid());
                newWindow(newBank?.connection?.link);
                await onConnected();
            }
        )
    }

    return <Modal title="Connect a bank" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        <Search>
            <SearchBar />
            {banks && <Inner banks={banks} handleSelect={handleSelect} />}
        </Search>
    </Modal>
}

const Inner = ({banks, handleSelect}) => {
    const {searchData} = useSearch();
    const filteredBanks = useMemo(() => {
        return banks.filter(b => b.countries.includes('GB') || b.countries.includes('XX'))
            .filter(b => !searchData.search || b.name.toLowerCase().indexOf(searchData.search.toLowerCase()) !== -1)
    }, [banks, searchData])

    return <div className="grid grid-cols-2 mt-3 overflow-y-scroll max-h-[75vh]">
        {filteredBanks.map(bank => {
            return <button key={bank.id}
                className="-mt-px -ml-px border p-4 text-center leading-tight"
                onClick={(e) => handleSelect(e, bank)}
            >
                <img src={bank.logo} alt={`Logo of ${bank.name}`} className="h-8 w-auto mx-auto" />
                <span className="text-muted text-sm">{bank.name}</span>
            </button>
        })}
    </div>
}

export default ConnectABank;
